import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'
import RenderEmployeeList from "../../_functions/EmployeeRenders";
import FetchEmployee from 'utils/fetch/FetchEmployee'
import ThemedLoader from 'components/atoms/ThemedLoader'
import i18n from "utils/i18n";
import ThemedInputSearch from 'components/atoms/ThemedInputSearch'
import _ from 'lodash'
import ThemedBlock from 'components/atoms/ThemedBlock'
import HelperString from 'utils/helper-string'
import { ThemedValues } from 'styles/themed'
import VStack from 'components/atoms/stack/VStack'

const HomeBookSelectCoworkerIndexTabCoWorkers = () => {
	
	const _employee = useSelector( state => {
		return state.data[dataConstants.EMPLOYEE];
	} );
	
	const [ teamEmployees, setTeamEmployees ] = useState( [] );
	const [ employees, setEmployees ] = useState( [] );
	const [ isLoading, setIsLoading ] = useState( false );
	const [ isSearching, setIsSearching ] = useState( false );
	const [ searchValue, setSearchValue ] = useState( '' );
	
	const loading = () => {
		setIsLoading(true);
	}
	const loaded = () => {
		setIsLoading(false);
	}
	const searching = () => {
		setIsSearching(true);
	}
	const searched = () => {
		setIsSearching(false);
	}
	
	const fetchedTeamMembers = ( { employees } ) => {
		setTeamEmployees( employees );
		loaded();
	}
	
	const fetchTeamMembers = () => {
		if( !isLoading && _.size( teamEmployees ) === 0 ) {
			FetchEmployee.fetchAll( {
				teamGuid: _.get( _employee, [ 'team', 'guid' ], '-none-' ),
				callbackStart: loading,
				callbackError: loaded,
				callbackSuccess: fetchedTeamMembers
			} );
		}
	}
	
	const searchedEmployees = ( { employees } ) => {
		setEmployees( employees );
		searched();
	}
	
	const searchEmployees = () => {
		FetchEmployee.search( {
			_employee: _employee,
			searchValue: searchValue,
			callbackStart: searching,
			callbackError: searched,
			callbackSuccess: searchedEmployees
		} );
	}
	
	const searchEmployeeDebounce = useCallback(_.debounce( searchEmployees, 800, [] ));
	
	useEffect( () => {
		if( searchValue.length > 2 ) {
			searchEmployeeDebounce();
		}else if( searchValue.length === 0 ){
			fetchTeamMembers();
		}
	}, [ searchValue ] );
	
	const content = [
		<ThemedBlock
			key={ HelperString.hash('coworker-tab-coworker-block') }
			shadow
			smallPadding>
			
			<ThemedInputSearch
				initialValue={ searchValue }
				placeholder={ i18n.t( 'page.create.coworker.search.input_search') }
				onChangeText={ _.debounce( setSearchValue, 500 ) }
				returnKeyType={ "search" }
				onSubmitEditing={ searchEmployees }
			/>
		</ThemedBlock>
	];
	
	switch( true ) {
		case isLoading:
			content.push(
				<ThemedLoader
					key={ HelperString.hash('coworker-tab-coworker-loading-members') }
					text={ i18n.t( 'loading.team_members' ) }
				/>
			)
			break;
			
		case isSearching:
			content.push(
				<ThemedLoader
					key={ HelperString.hash('coworker-tab-loading-search') }
					text={ i18n.t( 'loading.search_results' ) }
				/>
			)
			break;
			
		default:
			content.push(
				<RenderEmployeeList
					key={ HelperString.hash('coworker-tab-coworker-list') }
					employees={ searchValue.length > 2 ? employees : teamEmployees }
				/>
			)
	}
	
	return (
		<VStack
			flex={ 1 }
			space={ ThemedValues.stackSpace }>
			
			{ content }
		</VStack>
	)
}

export default HomeBookSelectCoworkerIndexTabCoWorkers;
